export default "__VITE_ASSET__CN74XhQ5__"